import script from "./TableReport.vue?vue&type=script&setup=true&lang=js"
export * from "./TableReport.vue?vue&type=script&setup=true&lang=js"

import "./TableReport.vue?vue&type=style&index=0&id=331dd6c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331dd6c0"]])

export default __exports__